import { ReactElement } from "react";
import styles from './NoData.module.scss';

interface NoDataProps
{
    badgeText?: string;
    message: string;
}

const NoData = (props: NoDataProps): ReactElement | null =>
{
    return (
        <div className={styles.wrapper}>
            <span>{props.badgeText ? props.badgeText : "No issues"}</span>
            <p>{props.message}</p>
        </div>
    );
}

export default NoData;